import { render, staticRenderFns } from "./OnlineConsultation.vue?vue&type=template&id=43ec3c50"
import script from "./OnlineConsultation.vue?vue&type=script&lang=js"
export * from "./OnlineConsultation.vue?vue&type=script&lang=js"
import style0 from "./OnlineConsultation.vue?vue&type=style&index=0&id=43ec3c50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports